export default [
  {
    path: "/roles",
    component: () => import("../layout"),
    children: [
      {
        path: "/roles",
        name: "roles.index",
        component: () => import("./index"),
      },
      {
        path: ":id",
        name: "roles.show",
        component: () => import("./show"),
      },
    ],
  },
];
